import {
    ChangeDetectorRef,
    Component,
    forwardRef,
    HostBinding,
    inject,
    input,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {
    AbstractControl,
    ControlContainer,
    ControlValueAccessor,
    FormGroupDirective,
    FormsModule,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ReactiveFormsModule,
    ValidationErrors,
    Validator
} from '@angular/forms';
import { FloatLabel } from 'primeng/floatlabel';
import { InputNumber, InputNumberModule } from 'primeng/inputnumber';

@Component({
    selector: 'z-float-label-percent',
    imports: [InputNumberModule, FloatLabel, FormsModule, ReactiveFormsModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ZFloatLabelPercentComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: ZFloatLabelPercentComponent
        }
    ],

    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    templateUrl: './z-float-label-percent.component.html',
    styleUrl: './z-float-label-percent.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class ZFloatLabelPercentComponent
    implements ControlValueAccessor, Validator
{
    @ViewChild('inputNumber') inputNumber?: InputNumber;
    @HostBinding('class') class?: string = 'flex grow';
    inputStyle = input<{ [k: string]: any }>();
    inputClassStyle = input<string | undefined>('flex grow');
    labelClassStyle = input<string | undefined>('flex grow');

    label = input<string | undefined>(undefined);
    autocomplete = input<string | undefined>(undefined);
    id = input<string | undefined>(undefined);

    mode = input<string | undefined>('decimal');
    minFractionDigits = input<number | undefined>(0);
    maxFractionDigits = input<number | undefined>(2);
    min = input<number>(Number.MIN_VALUE);
    max = input<number>(Number.MAX_VALUE);
    step = input<number>(0);
    locale = input<string | undefined>('el-GR');
    suffix = input<string | undefined>('');
    prefix = input<string | undefined>(undefined);

    onKeyDown($event: KeyboardEvent) {
        if ($event.code == 'NumpadEnter' || $event.code == 'Enter') {
            if ($event.code == 'NumpadEnter' || $event.code == 'Enter') {
                $event.stopPropagation();
                $event.preventDefault();
                setTimeout(() => {
                    const tabKey = new KeyboardEvent('keydown', {
                        view: window,
                        code: 'Tab',
                        key: 'Tab',
                        bubbles: true,
                        cancelable: true
                    });

                    this.inputNumber?.input?.nativeElement?.dispatchEvent(
                        tabKey
                    );
                }, 300);
            }
        }
    }

    /* NG_VALUE_ACCESSOR Implementation */
    // https://blog.angular-university.io/angular-custom-form-controls/
    disabled?: boolean;
    model: any;
    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    writeValue(obj: number | undefined): void {
        if (obj != undefined) this.model = obj * 100;
    }
    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }
    registerOnValidatorChange?(fn: () => void): void {
        // throw new Error('Method not implemented.');
    }
    /* /NG_VALUE_ACCESSOR Implementation */

    onModelValueChange(percent: number) {
        this.onModelChange(percent / 100);
    }
}
